// Google-Meet-style countdown: appears only in the final stretch before the org
// duration cap force-ends the meeting (Phase C). Self-contained 1s ticker so it
// never re-renders the controls bar. Sits left of the Files button.

import { memo, useEffect, useState } from 'react';

import { useCallStore } from '../store/callStore';
import { IconClock } from '../ui/icons';

// Show the pill once under this many seconds remain; turn urgent under a minute.
const SHOW_UNDER_SEC = 5 * 60;
const URGENT_UNDER_SEC = 60;

export const MeetingCountdown = memo(function MeetingCountdown() {
  const endsAt = useCallStore((s) => s.meetingEndsAt);
  const [nowSec, setNowSec] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    if (!endsAt) return;
    const id = window.setInterval(() => setNowSec(Math.floor(Date.now() / 1000)), 1000);
    return () => window.clearInterval(id);
  }, [endsAt]);

  if (!endsAt) return null;
  const remaining = endsAt - nowSec;
  if (remaining > SHOW_UNDER_SEC || remaining < 0) return null;

  const mm = Math.floor(remaining / 60);
  const ss = remaining % 60;
  const urgent = remaining <= URGENT_UNDER_SEC;

  return (
    <div
      className={urgent ? 'bz-countdown bz-countdown-urgent' : 'bz-countdown'}
      role="timer"
      aria-live="off"
      title="Time left before the meeting reaches its limit"
    >
      <IconClock size={15} />
      <span className="bz-countdown-time">
        {mm}:{String(ss).padStart(2, '0')}
      </span>
    </div>
  );
});
